import * as React from 'react';
import RevenueCalendar from './RevenueCalendar';
import MonthlyBillingProgress from './MonthlyBillingProgress';
import BillingEventsList from './BillingEventsList';

interface SubscriptionRevenueCalendarProps {
  isLoading?: boolean;
  filters?: { plan_filter?: string; utm_source_filter?: string };
}

const SubscriptionRevenueCalendar: React.FC<SubscriptionRevenueCalendarProps> = ({ isLoading = false, filters }) => {
  const [selectedDate, setSelectedDate] = React.useState<string>();
  const dateFieldId = React.useId();

  return <>
    <div className="row mb-4">
      <div className="col-12">
        <RevenueCalendar isLoading={isLoading} filters={filters} height={700}
          onDateClick={setSelectedDate}
          onEventClick={event => setSelectedDate(event.start.split('T')[0])} />
      </div>
    </div>
    <div className="row mb-4">
      <div className="col-lg-6">
        <MonthlyBillingProgress isLoading={isLoading} filters={filters} height={350} />
      </div>
      <div className="col-lg-6">
        <div className="mb-3">
          <label htmlFor={dateFieldId} className="form-label">Billing date</label>
          <input id={dateFieldId} type="date" className="form-control" value={selectedDate || ''}
            onChange={event => setSelectedDate(event.target.value || undefined)} />
        </div>
        <BillingEventsList selectedDate={selectedDate} isLoading={isLoading} filters={filters}
          onClose={() => setSelectedDate(undefined)} />
      </div>
    </div>
  </>;
};

export default SubscriptionRevenueCalendar;
